module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_12-1f9576cbbe5422447e5ba7a88aebcc61.jpg";